export const ORG_CHAT_THREADS_QUERY_KEY = "orgChatThreadsInfinite";
